import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { Message_Type } from 'src/app/core/models/enums/message-type';
import { ModalService } from 'src/app/core/services/modal.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { SensorInfoService } from '../../services/sensor-info.service';

@Component({
  selector: 'app-enter-confirm-id',
  templateUrl: './enter-confirm-id.component.html',
  styleUrls: ['./enter-confirm-id.component.scss'],
})
export class EnterConfirmIdComponent extends BaseModal implements OnInit {
  @Input() deviceID: string;
  @Input() header: string;
  @Input() button: string;
  @Input() id: number;
  @Input() type: string;
  isValid: boolean = true;
  deviceId2: string = "";
  isFiliz: boolean = false;
  formatNumber = /[1234567890]/;
  isNumber: boolean = true;
  deviceArr: Array<any> = [];
  constructor(private modalService: ModalService, private sensorInfoService: SensorInfoService, private toastService: ToastService,
    private translateService: TranslateService) {
    super();
    super._modalService = modalService;
  }

  ngOnInit() {
    super.ngOnInit();
  }

  deviceChange() {
    this.deviceArr = [];
    this.deviceId2=""
    this.deviceArr.push(...this.deviceID);
    this.deviceArr.forEach(e => {
      this.isNumber = this.formatNumber.test(e);
      if (this.isNumber) {
        this.deviceId2 = this.deviceId2 + e;
      }
    })
    if (this.deviceId2?.length != 8) {
      this.isValid = false;
    } else {
      this.isValid = true;
    }
  }

  save() {
    this.deviceArr = [];
    this.deviceId2=""
    this.deviceArr.push(...this.deviceID);
    this.deviceArr.forEach(e => {
      this.isNumber = this.formatNumber.test(e);
      if (this.isNumber) {
        this.deviceId2 = this.deviceId2 + e;
      }
    })
    if (this.deviceId2?.length != 8) {
      this.isValid = false;
    } else {
      this.isValid = true;
    }
    this.sensorInfoService.deviceExist({ deviceId: this.deviceId2, deviceType: this.type }).subscribe(e => {
      if (e.IsSuccess) {
        if (e.Data) {
          this.modalService.dismissByModalId(this.id, this.deviceId2);
        } else {
          this.toastService.PresentBasicToast({ message: this.translateService.instant("device-field-add.device-not-exist"), type: Message_Type.WARNING });
        }
      } else {
        this.toastService.PresentBasicToast({ message: this.translateService.instant("device-field-add.device-not-exist"), type: Message_Type.WARNING });
      }
    });
  }


}
